import { Component, inject, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { mailRegex } from 'src/app/shared/constants/mailRegex.constants';
import { allowLimitedInput, allowOnlyLetters, trimInput, handlePasteText } from '../../master.utils';
import { allowOnlyNumbers, MaVessel } from '../create-client/vessel.model';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { ToastrService } from 'ngx-toastr';
import { VesseService } from 'src/app/shared/service/disbursment/vessel.service';

@Component({
  selector: 'app-create-vessel',
  templateUrl: './create-vessel.component.html',
  styleUrls: ['./create-vessel.component.scss']
})
export class CreateVesselComponent {
vesselForm: FormGroup;
  isEditMode = false;
  allowLimitedInput = allowLimitedInput;
  allowOnlyNumbers = allowOnlyNumbers;
  disallowNumericData = allowOnlyLetters;
  private vesselClass: MaVessel = new MaVessel();

 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;
  constructor(private fb: FormBuilder, private vesselService: VesseService, @Inject(MAT_DIALOG_DATA) private existingdata: any, private snackBar: ToastrService,
    private dialogRef: MatDialogRef<CreateVesselComponent>) {
    const data = existingdata?.rowData || {};
    this.isEditMode = !!existingdata;
    this.vesselForm = this.fb.group({
      vessel_id: [data?.vessel_id || 0],
      name: [data?.name || '', [Validators.required]],
      imo_number: [data?.imo_number || "", [Validators.required, Validators.pattern(/^\d{7}$/)]],
      grt: [data?.grt || '', [Validators.required, this.positiveNumberValidator]],
      rgrt: [data?.rgrt || '', [this.positiveNumberValidator]],
      nrt: [data?.nrt || '', [Validators.required, this.positiveNumberValidator]],
      loa: [data?.loa || '', [Validators.required, this.positiveNumberValidator]],
      beam: [data?.beam || '', [Validators.required, this.positiveNumberValidator]],
      depth: [data?.depth || '', [Validators.required, this.positiveNumberValidator]],
      type: [data?.type || '', [Validators.required]],
      dwt: [data?.dwt || '', [Validators.required, this.positiveNumberValidator]],
      displayFlag: [data?.displayFlag || "Y"],
      email: [data?.email || '', [Validators.email, Validators.pattern(mailRegex)]],
      is_manual: [data?.is_manual || "Y"],
      //  status: [data?.status === 'Inactive' ? false : true],
    });
  }

  ngOnInit() {
    if (this.isEditMode) {
      this.vesselForm.get('imo_number')?.disable();
    }

  }

  // method to create the vessel when the add vessel button is clicked
  onSubmit(): void {
    if (this.vesselForm.valid) {
      this.loader.showDialogLoader();
      const formValue = {
        ...this.vesselForm.value,
        name: this.vesselForm.value.name.trim(),
        status: this.vesselClass.status
      };
      this.vesselService.VesselDataToDB(formValue)
        .subscribe({
          next: (response:any) => {
            this.loader.hideDialogLoader();
            this.snackBar.success(response.message);
            this.dialogRef.close('refresh');
          }, error: (err:any) => {
            this.loader.hideDialogLoader();
            const errorMsg = err.error?.error || 'Something went wrong. Please try again.';
            this.snackBar.error(errorMsg);
          }
        });
    } else {
      this.snackBar.error('Please use valid informations.');
    }
  }
  //method to trim the input
  onInputTrim(controlName: string): void {
    const control = this.vesselForm.get(controlName);
    trimInput(control);
  }

  // method to handle the paste event
  onPaste(event: ClipboardEvent): void {
    const input = event.target as HTMLInputElement;
    const controlName = input.getAttribute('formControlName');
    if (!controlName) return;
    const value = handlePasteText(event);
    this.vesselForm.get(controlName)?.setValue(value);
  }


  // method to allow only positive numbers
  positiveNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;
    return Number(value) >= 0 ? null : { negativeNumber: true };
  }

  // method to close the dialog
  closeDialog() {
    this.dialogRef.close();
  }
}
